import * as Yup from "yup";

export const totalLearnsValidation = Yup.object().shape({
  value: Yup.string().required("وارد کردن تعداد الزامی است"),
});
